import React, { useContext } from 'react'
import PropType from 'prop-types'

import WidgetContext from 'components/widget-context'
import withApolloProvider from 'components/hocs/withApolloProvider'
import getLayoutConfig from 'utils/getLayoutConfig'

import Footer from '../footer'
import interactiveConfig from './interactiveConfig'
import styles from '../copy-only/styles.module.scss'

const Interactive = (props) => {
  const { href, theme, title, body, ctaText, Form, queryString, metaQuery, verticals } = props
  const widgetContext = useContext(WidgetContext)
  const { AboveCta } = getLayoutConfig(theme, interactiveConfig)

  return (
    <div className={styles.container}>
      <AboveCta styles={styles} />
      <div className={styles.widgetContainer}>
        <div className={`${styles.widget} ${styles.interactive}`}>
          <div className={`${styles.copy} ${styles.interactive}`}>
            <p className={`${styles.title} ${styles.interactive} mb-8 heading bold`}>{title}</p>
            <p className={`${styles.body} mb-16 mb-sm-0`}>{body}</p>
          </div>
          <div className={`${styles.cta} ${styles.interactive}`}>
            <Form
              href={href}
              theme={theme}
              ctaText={ctaText}
              widgetContext={widgetContext}
              queryString={queryString}
              metaQuery={metaQuery}
            />
          </div>
        </div>
        <Footer show verticals={verticals} theme={theme} />
      </div>
    </div>
  )
}

Interactive.propTypes = {
  href: PropType.string.isRequired,
  title: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  Form: PropType.func,
  queryString: PropType.string,
  metaQuery: PropType.string,
  verticals: PropType.oneOfType([PropType.string, PropType.array]),
}

export { Interactive }

export default withApolloProvider(Interactive)
